<template>
  <div class="page-title">
    <template>
      <span>虚拟表</span>
      <br />
      <a-space>
        <a-input v-model="searchParams.virtualTableName" placeholder="请输入虚拟表名称" style="width: 400px"></a-input>
        <a-select v-model="searchParams.status" placeholder="请选择状态" style="width: 100px; align-content: center">
          <a-select-option :value="1">
            启用
          </a-select-option>
<!--          <a-select-option :value="0">-->
<!--            禁用-->
<!--          </a-select-option>-->
        </a-select>
      </a-space>
      <a-button class="create-btn" type="primary" icon="plus-circle-o" @click="addClick">新增</a-button>
      <a-button class="filter-btn" type="primary" icon="search" @click="queryVirtualTablePage">搜索</a-button>
    </template>
    <a-table
        :columns="columns"
        :row-key="record => record.id"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
    >
      <template slot="handle" slot-scope="text, record">
        <a-space>
          <a-popconfirm
              v-if="dataSource.length"
              title="确定删除吗?"
              @confirm="() => deleteClick(record.key)"
          >
            <a-button type="danger" title="删除">
              删除
            </a-button>
          </a-popconfirm>
          <a-button type="primary" title="查看" @click="viewClick(record)">
            查看
          </a-button>
          <a-button type="primary" title="编辑" @click="editClick(record)">
            编辑
          </a-button>
        </a-space>
      </template>
    </a-table>
    <a-modal title="详情" v-model="detailVisible" @ok="detailVisible=!detailVisible" :keyboard=true width="1200px">
      <a-radio-group v-model="detailVisibleType" @change="handleDetailChange">
        <a-radio-button value="Parameter" width="200">
          Parameter
        </a-radio-button>
        <a-radio-button value="SQL" width="200">
          SQL
        </a-radio-button>
      </a-radio-group>
      <p>{{ detailParams }}</p>
    </a-modal>
    <a-modal v-model="addVisible" title="新增" @ok="addVT" @cancel="cancelAdd" width="1200px" :confirmLoading="addLoading">
      <a-textarea
          v-model="addParam"
          placeholder="请输入最新的虚拟表参数"
          :auto-size="{ minRows: 3, maxRows: 50 }"
      />
    </a-modal>
    <a-modal v-model="updateVisible" title="更新" @ok="updateVT" @cancel="cancelUpdate" width="1200px" :confirmLoading="updateLoading">
      <a-textarea
          v-model="updateParam"
          placeholder="请输入要新增的虚拟表参数"
          :auto-size="{ minRows: 3, maxRows: 50 }"
      />
    </a-modal>
  </div>
</template>
<script>
import {add, queryPage} from "@/api/virtualTable"

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 80,
  },
  {
    title: '名称',
    dataIndex: 'virtualTableName',
    key: 'virtualTableName',
    width: 300,
  },
  {
    title: '关联表ID',
    dataIndex: 'tableIdList',
    key: 'tableIdList',
    ellipsis: true,
    width: 100,
  },
  {
    title: 'SQL',
    dataIndex: 'wholeSql',
    key: 'wholeSql',
    ellipsis: true,
  },
  {
    title: '参数JSON',
    dataIndex: 'paramJson',
    key: 'paramJson',
    ellipsis: true,
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    ellipsis: true,
    width: 100,
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    ellipsis: true,
  },
  {
    title: '操作',
    dataIndex: 'handle',
    key: 'handle',
    ellipsis: true,
    align: 'center',
    scopedSlots: { customRender: 'handle' },
    width: 250,
  }
];
const initSearchParams = {
  virtualTableName: undefined,
  status: 1,
}
export default {
  name: 'VirtualTable',
  data() {
    return {
      updateVisible: false,
      addVisible: false,
      detailVisible: false,
      detailVisibleType: 'Parameter',
      detail: {},
      detailParams: {},
      dataSource: [],
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10
      },
      loading: false,
      updateLoading: false,
      addLoading: false,
      columns,
      searchParams: this.$deepclone(initSearchParams),
      updateParam: '',
      addParam: '',
    };
  },
  mounted() {
    this.queryVirtualTablePage();
  },
  methods: {
    handleTableChange(page) {
      this.pagination = page
      this.queryVirtualTablePage()
    },
    queryVirtualTablePage() {
      this.loading = true
      queryPage({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        ...this.searchParams
      }).then((res) => {
        this.dataSource = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
    addClick(){
      this.addVisible = true;
    },
    viewClick(record){
      this.detailVisible = true
      this.detail = record
      if(this.detailVisibleType === 'Parameter'){
        this.detailParams = this.detail.paramJson
      }else {
        this.detailParams = this.detail.wholeSql
      }
    },
    editClick(){
      this.updateVisible = true;
    },
    deleteClick(){
      this.$notification.open({
        message: '非法操作',
        description: '非法操作：不允许删除！',
        icon: <a-icon type="warning" style="color: red" />,
      });
    },
    handleDetailChange(val){
      this.viewClick(this.detail)
    },
    updateVT(){
      this.updateLoading = true
      add(JSON.parse(this.updateParam)).then((res) => {
        this.$message.success('更新成功！')
        this.queryVirtualTablePage()
      }).finally(() => this.updateLoading = false, this.updateVisible = false, this.updateParam = '')
    },
    cancelUpdate(){
      this.updateParam = '';
    },
    addVT(){
      this.addLoading = true
      add({
        ... JSON.parse(this.addParam),
        id: undefined
      }).then((res) => {
        this.$message.success('新增成功！')
        this.queryVirtualTablePage()
      }).finally(() => this.updateLoading = false, this.addVisible = false, this.addParam = '')
    },
    cancelAdd(){
      this.addParam = '';
    }
  },
};
</script>
<style lang="less" scoped>
.page-tabs {
  margin-top: 24px;
  padding-left: 24px;
  /deep/ .ant-tabs-bar {
    border-bottom: none;
  }
}
.update-point {
  padding-left: 10px;
  font-size: 14px;
}
</style>